const ComplaintReducer = (state, action) => {
    switch (action.type) {

        case "GET_COMPLAINTS_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "GET_COMPLAINTS_SUCCESS":
            return {
                ...state,
                complaints: action.payload,
                isFetching: false,
                error: false,
                hasFetched: true,
            };

        case "GET_COMPLAINTS_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
                hasFetched: false,
            };

        case "UPDATE_COMPLAINTS_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "UPDATE_COMPLAINTS_SUCCESS":
            return {
                ...state,
                complaints: state.complaints.map((complaint) =>
                    complaint._id === action.payload._id
                        ? action.payload
                        : complaint
                ),
                isFetching: false,
                error: false,
            };

        case "UPDATE_COMPLAINTS_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
            };

        default:
            return state;
    }
};

export default ComplaintReducer;